import React, { useEffect } from 'react';
import { useMailbox } from '../../context/MailboxContext';
import { useTranslation } from 'react-i18next';
import PlatformNotificationToast from '../common/PlatformNotificationToast.jsx';
import { useLocation, useNavigate } from 'react-router-dom';

export const isDesktopMailboxViewport = () => {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia('(min-width: 1024px)').matches;
  }
  return window.innerWidth >= 1024;
};

export default function NotificationToast({ onOpen }) {
  const { latestNotification, clearLatestNotification } = useMailbox();
  const { t } = useTranslation('menu');
  const navigate = useNavigate();
  const location = useLocation();
  const portalRoot =
    typeof document !== 'undefined'
      ? document.getElementById('modal-root') || document.body
      : null;

  const handleDismiss = () => {
    clearLatestNotification();
  };

  // Автоматическое скрытие через 10 секунд
  useEffect(() => {
    if (latestNotification) {
      const timer = setTimeout(() => {
        clearLatestNotification();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [latestNotification, clearLatestNotification]);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        clearLatestNotification();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [clearLatestNotification]);

  // Не рендерим, если нет новых уведомлений
  if (!latestNotification) return null;

  return (
    <PlatformNotificationToast
      badge={t('mailbox.list.badge')}
      title={latestNotification.title}
      message={latestNotification.message}
      openAriaLabel={t('mailbox.toast.open')}
      onDismiss={handleDismiss}
      onOpen={() => {
        clearLatestNotification();
        if (typeof onOpen === 'function') {
          onOpen(latestNotification);
          return;
        }
        if (isDesktopMailboxViewport()) {
          const returnTo = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
          navigate('/menu/mailbox', {
            state: {
              notification: latestNotification,
              notificationId: latestNotification?.id || null,
              returnTo: returnTo || '/menu/chats',
            },
          });
          return;
        }
        navigate('/vault/main?open_mailbox=1');
      }}
      portalRoot={portalRoot}
    />
  );
}
